var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Competitions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043E\\u0440\\u0435\\u0432\\u043D\\u043E\\u0432\\u0430\\u043D\\u0438\\u044F.-\\u0421\\u043F\\u0438\\u0441\\u043E\\u043A-\\u0443\\u0447\\u0430\\u0441\\u0442\\u043D\\u0438\\u043A\\u043E\\u0432.-\\u041F\\u0440\\u043E\\u0441\\u043C\\u043E\\u0442\\u0440-\\u043B\\u043E\\u0433\\u043E\\u0432",
    transform: "translate(-1201.000000, -257.000000)",
    fill: "#BABABA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(760.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(420.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/24_cross",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4142136,12 L20.7071068,19.2928932 C21.0976311,19.6834175 21.0976311,20.3165825 20.7071068,20.7071068 C20.3165825,21.0976311 19.6834175,21.0976311 19.2928932,20.7071068 L12,13.4142136 L4.70710678,20.7071068 C4.31658249,21.0976311 3.68341751,21.0976311 3.29289322,20.7071068 C2.90236893,20.3165825 2.90236893,19.6834175 3.29289322,19.2928932 L10.5857864,12 L3.29289322,4.70710678 C2.90236893,4.31658249 2.90236893,3.68341751 3.29289322,3.29289322 C3.68341751,2.90236893 4.31658249,2.90236893 4.70710678,3.29289322 L12,10.5857864 L19.2928932,3.29289322 C19.6834175,2.90236893 20.3165825,2.90236893 20.7071068,3.29289322 C21.0976311,3.68341751 21.0976311,4.31658249 20.7071068,4.70710678 L13.4142136,12 Z",
    id: "Color"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonIcon);
export default __webpack_public_path__ + "static/media/close-button-icon.7d7ed5bb0ad5040f604028651cb1a9dc.svg";
export { ForwardRef as ReactComponent };